/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProjectCategory,
    ProjectCategoryFromJSON,
    ProjectCategoryFromJSONTyped,
    ProjectCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedProjectCategoryList
 */
export interface PaginatedProjectCategoryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectCategoryList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectCategoryList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectCategoryList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ProjectCategory>}
     * @memberof PaginatedProjectCategoryList
     */
    results?: Array<ProjectCategory>;
}

export function PaginatedProjectCategoryListFromJSON(json: any): PaginatedProjectCategoryList {
    return PaginatedProjectCategoryListFromJSONTyped(json, false);
}

export function PaginatedProjectCategoryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedProjectCategoryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ProjectCategoryFromJSON)),
    };
}

export function PaginatedProjectCategoryListToJSON(value?: PaginatedProjectCategoryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ProjectCategoryToJSON)),
    };
}

